module.exports = __webpack_public_path__ + "media/images/icon__nativeAppShare-ef42d0a5521366d1ab75997e39721577.png";